import IpSetIconImageLight from "./../../icons/default/ipsetLight.png";

import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const IpSetLightIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return <img style={style} className={className} src={IpSetIconImageLight} />;
};
